import { render, staticRenderFns } from "./EchoData.vue?vue&type=template&id=1cfb512d&scoped=true"
import script from "./EchoData.vue?vue&type=script&lang=js"
export * from "./EchoData.vue?vue&type=script&lang=js"
import style0 from "./EchoData.vue?vue&type=style&index=0&id=1cfb512d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb512d",
  null
  
)

export default component.exports